import { useState, useEffect } from "react";
import { LayoutDashboard, Disc3, User, BarChart3, CreditCard, DollarSign, LifeBuoy } from "lucide-react";
import DashboardShell from "@/components/dashboard/DashboardShell";
import { useAuth } from "@/context/AuthContext";
import ArtistOverview from "./ArtistOverview";
import ArtistReleases from "./ArtistReleases";
import ArtistAnalytics from "./ArtistAnalytics";
import ArtistProfile from "./ArtistProfile";
import ArtistRoyalties from "./ArtistRoyalties";
import BillingPanel from "@/components/billing/BillingPanel";
import ArtistTickets from "@/components/support/ArtistTickets";

export default function ArtistApp() {
  const { user } = useAuth();
  // Land on the right tab based on the URL param the browser arrived on.
  // - ?billing=return  → Billing (Stripe subscription roundtrip)
  // - ?tier=<...>      → Billing (landing-page pricing CTA)
  // - ?dolby_paid=<id> → My Releases (Stripe $40 add-on roundtrip; the ArtistReleases
  //                     useEffect will POST /dolby-sync + /submit)
  const initialTab = (() => {
    if (typeof window === "undefined") return "overview";
    const q = new URLSearchParams(window.location.search);
    if (q.get("billing") === "return") return "billing";
    if (q.get("tier")) return "billing";
    if (q.get("dolby_paid")) return "releases";
    return "overview";
  })();
  const [active, setActive] = useState(initialTab);

  useEffect(() => {
    // Nothing to do — BillingPanel reads ?tier= and ?billing=return from the URL
    // on mount, kicks off checkout / sync, and clears the params afterwards.
  }, []);

  const nav = [
    { key: "overview", label: "Overview", icon: LayoutDashboard },
    { key: "releases", label: "My Releases", icon: Disc3 },
    { key: "analytics", label: "Analytics", icon: BarChart3 },
    { key: "royalties", label: "Royalties", icon: DollarSign },
    { key: "support", label: "Support", icon: LifeBuoy },
    { key: "billing", label: "Billing", icon: CreditCard },
    { key: "profile", label: "Profile", icon: User },
  ];

  const titles = {
    overview: "Overview", releases: "My Releases", analytics: "Analytics",
    royalties: "Royalties", support: "Support", billing: "Billing", profile: "Profile",
  };
  const roleBadge = user?.role === "label" ? "Label" : "Artist";

  return (
    <DashboardShell title={titles[active]} badge={roleBadge} nav={nav} active={active} setActive={setActive}>
      {active === "overview" && <ArtistOverview goto={setActive} />}
      {active === "releases" && <ArtistReleases />}
      {active === "analytics" && <ArtistAnalytics />}
      {active === "royalties" && <ArtistRoyalties />}
      {active === "support" && <ArtistTickets />}
      {active === "billing" && <BillingPanel tiers={["artist", "pro"]} />}
      {active === "profile" && <ArtistProfile />}
    </DashboardShell>
  );
}
